module.exports = __webpack_public_path__ + "static/fonts/DejaVuSans-Oblique.8723fc1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSans-Oblique.ttf?v=1.1
// module id = 1635
// module chunks = 28